import moment from 'moment'
moment.locale('ru')

export const workDates = function () {
  let result = []
  let time = moment()
  time.minute(0).second(0)
  for (let i = 1; i <= 7; i++) {
    time.weekday(i - 1)
    time.minute(0).second(0)
    let item = {
      id: i,
      name: time.format('dddd').toString(),
      selected: false
    }
    result.push(item)
  }

  return result
}
/**
 * Метод возвращает название дня по id
 * @param {Number} id
 * @param {Boolean} fullName - Полное ли название вернуть
 * @returns {String}
 */
export const getDayName = function (id, fullName = false) {
  let time = moment()
  time.weekday(id - 1)
  time.minute(0).second(0)
  let format = fullName ? 'dddd' : 'dd'
  return time.format(format).toString()
}



// WEBPACK FOOTER //
// ./src/helpers/workDates.js